export const NEGOTIATION_SNAPSHOT_STATE = {
  pending: 'pending',
  accepted: 'accepted',
  withdrawn: 'withdrawn',
  rejected: 'rejected',
} as const;

export type NegotiationSnapshotState =
  (typeof NEGOTIATION_SNAPSHOT_STATE)[keyof typeof NEGOTIATION_SNAPSHOT_STATE];

export type GigDeliverableChange = {
  kind: string;
  oldRequiredCount: number | null;
  newRequiredCount: number | null;
  campaignNetwork: string | null;
  displayText: string | null;
};

export type NegotiationSnapshot = {
  id: string;
  costInCents: number;
  previousCostInCents: number;
  contentAgreementTimePeriodInMonths: number | null;
  previousContentAgreementTimePeriodInMonths: number | null;
  state: NegotiationSnapshotState;
  gigDeliverableChanges: GigDeliverableChange[];
  brandNegotiation?: {
    id: string;
    state: NegotiationSnapshotState;
    contract?: {id: string};
  };
};
